import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { usePlatformNavStore } from '@/store/usePlatformNavStore';
import {
  menuPathAllowedByRoleConfig,
  platformRoutePermissionAllowed,
  tenantRoutePermissionAllowed,
} from '@/lib/route-access';
import type { ForbiddenNavigateState } from '@/lib/forbidden-route-state';

/** 运营后台：权限 + menuKeys 与 Sidebar 一致；拒绝时进 /403 并区分原因 */
export function RequirePlatformRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const perms = useAuthStore((s) => s.user?.permissions ?? []);
  const menuKeys = useAuthStore((s) => s.user?.menuKeys);
  const dynamic = usePlatformNavStore((s) => s.routePermissionOverrides);
  const { pathname } = useLocation();

  if (!platformRoutePermissionAllowed(pathname, perms, dynamic)) {
    const state: ForbiddenNavigateState = { from: pathname, reason: 'permission' };
    return <Navigate to="/403" replace state={state} />;
  }
  if (!menuPathAllowedByRoleConfig(pathname, menuKeys)) {
    const state: ForbiddenNavigateState = { from: pathname, reason: 'menu' };
    return <Navigate to="/403" replace state={state} />;
  }
  return <>{children}</>;
}

/** 租户门户：同上 */
export function RequireTenantRoute({ children }: { children: React.ReactNode }) {
  const perms = useAuthStore((s) => s.user?.permissions ?? []);
  const menuKeys = useAuthStore((s) => s.user?.menuKeys);
  const { pathname } = useLocation();

  if (!tenantRoutePermissionAllowed(pathname, perms)) {
    const state: ForbiddenNavigateState = { from: pathname, reason: 'permission' };
    return <Navigate to="/403" replace state={state} />;
  }
  if (!menuPathAllowedByRoleConfig(pathname, menuKeys)) {
    const state: ForbiddenNavigateState = { from: pathname, reason: 'menu' };
    return <Navigate to="/403" replace state={state} />;
  }
  return <>{children}</>;
}
